import robuxModule from "../robuxModule";

function robuxSubscriptionUpsellContainer($compile, $filter, premiumService, premiumConstants, premiumConstantsService) {
    "ngInject";

    return {
        restrict: "A",
        scope: false,
        templateUrl: premiumConstants.templates.robuxSubscriptionUpsellContainer,
        link: function (scope) {
            scope.subscribePageUrl = premiumService.getSubscriptionPageUrl();
            scope.isShowSuperValue = false; //default hide the super value session
            setPageDescriptionElement();

            scope.moreRobuxBtnClicked = function () {
                if (!scope.isShowSuperValue)
                    scope.isShowSuperValue = true;
                premiumService.sendInteractionClickEvent(premiumConstants.pageContext.robux,
                    premiumConstants.streamEventParams.wantMoreBtn);
            }
            
            scope.linkClicked = function (linkType) {
                premiumService.sendInteractionClickEvent(premiumConstants.pageContext.robux, linkType);
            }

            function setPageDescriptionElement() {
                var subtitleElement = angular.element(".top-subtitle");
                if (!subtitleElement.childElementCount) {
                    var learnMoreLinkStart = "<a ng-href={{subscribePageUrl}} class=\"text-link\" ng-click=\"linkClicked('" + premiumConstants.streamEventParams.learnMoreLink + "')\">";
                    var pageSubtitle = $filter('translate')('Description.BuyMoreRobuxSubtitle', {
                        lineBreak: '<br/>',
                        learnMoreLinkStart: learnMoreLinkStart,
                        learnMoreLinkEnd: '</a>'
                    });
                    var template = $compile('<span>' + pageSubtitle + '</span>')(scope);
                    subtitleElement.append(template);
                }
            }
        }
    }
}

robuxModule
    .directive("robuxSubscriptionUpsellContainer", robuxSubscriptionUpsellContainer);

export default robuxModule;